import type { CallerType } from '@klaro7/shared-types';

/**
 * Etichetta di tipologia del chiamante mostrata SOLO al professionista accanto
 * al nome, nelle superfici di chiamata (modale in arrivo, schermata call, chat).
 * Deriva dai dati di sessione/wallet lato server (deriveCallerType).
 *
 * VINCOLO: non mostra MAI l'importo in € del credito del cliente — solo la
 * tipologia commerciale.
 */

const LABELS: Record<CallerType, string> = {
  welcome_bonus: 'Bonus 7 minuti',
  first_recharge_promo: 'Prima ricarica',
  paying: 'Pagante',
};

// Colore neutro-chiaro per le superfici CHIARE (modale bianco) e variante per
// le superfici DARK (call/chat a fondo navy).
const LIGHT_CLASSES: Record<CallerType, string> = {
  welcome_bonus: 'bg-amber-50 text-amber-700',
  first_recharge_promo: 'bg-brand-teal-50 text-brand-teal-600',
  paying: 'bg-green-50 text-green-700',
};

const DARK_CLASSES: Record<CallerType, string> = {
  welcome_bonus: 'bg-amber-400/20 text-amber-200',
  first_recharge_promo: 'bg-brand-teal-400/20 text-brand-cyan',
  paying: 'bg-green-400/20 text-green-200',
};

export function CallerTypeBadge({
  callerType,
  variant = 'light',
  className = '',
}: {
  callerType: CallerType;
  variant?: 'light' | 'dark';
  className?: string;
}) {
  const palette = variant === 'dark' ? DARK_CLASSES : LIGHT_CLASSES;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${palette[callerType]} ${className}`}
    >
      {LABELS[callerType]}
    </span>
  );
}
